var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.headerComponent,_vm._b({tag:"Component"},'Component',_vm.websiteHeaderProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }